module.exports = __webpack_public_path__ + "media/images/profile-6338da75.png";